import request from "@/service/index"
import {ILoginInfo} from "@/store/type"
import hyRequest from "@/service";
import { IDataType } from "@/service/type";

export function accountLoginRequest(loginInfo: ILoginInfo) {
  return hyRequest.post<IDataType>({
    url: "/user/login",
    data: loginInfo
  })
}


export function getUserInfoRequest() {
  return hyRequest.get<IDataType>({
    url: "/user/info"
  })
}
